export default __webpack_public_path__ + "static/media/compass.af30e419.svg";